<template>
    <not-landskape :p="text" />
</template>

<script>
import notLandskape from '@/components/NotLandskape/index.vue'

export default {
    components: {
        notLandskape
    },
    data: () => ({
        text: ''
    }),
    created() {
        if(this.$route.query.text) this.text = this.$route.query.text
    }
}
</script>